import { render } from "./SavePayoutAccountPrompt.vue?vue&type=template&id=f5d63f8a&scoped=true&ts=true"
import script from "./SavePayoutAccountPrompt.vue?vue&type=script&lang=ts"
export * from "./SavePayoutAccountPrompt.vue?vue&type=script&lang=ts"

import "./SavePayoutAccountPrompt.vue?vue&type=style&index=0&id=f5d63f8a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5d63f8a"],['__file',"src/components/payoutAccounts/SavePayoutAccountPrompt.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f5d63f8a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f5d63f8a', __exports__)) {
    api.reload('f5d63f8a', __exports__)
  }
  
  module.hot.accept("./SavePayoutAccountPrompt.vue?vue&type=template&id=f5d63f8a&scoped=true&ts=true", () => {
    api.rerender('f5d63f8a', render)
  })

}


export default __exports__